export default __webpack_public_path__ + "static/media/quarto4.ce079523.jpg";